// declare variables
var pageSlugName = window.location.pathname;

pageSlugName = pageSlugName.replace(/^\/|\/$/g, "");
pageSlugName = pageSlugName.split("/").join("-");

var dataTable = new bstackDataTable("#dataTableSection", {
  perPage: 10,
});

function fnRequestCertificateBtn(elem) {
  var reportName = elem
      .closest(".data-table__tbody")
      .querySelector(".data-table__desc").innerText,
    reportID = elem.getAttribute("data-report-id"),
    requestStatus,
    signinTrustModal = document.getElementById("signinTrustModal"),
    publicSigninTrustModal = document.getElementById("publicSigninTrustModal"),
    trustNDAModal = document.getElementById("trustNDAModal"),
    dataTableIcon = elem
      .closest(".data-table__tbody")
      .querySelector(".data-table__download-btn-icon"),
    dataTableLoader = elem
      .closest(".data-table__tbody")
      .querySelector(".data-table__loader-icon"),
    dataTableBtnText = elem
      .closest(".data-table__tbody")
      .querySelector(".data-table__download-btn-text");

  //disable button text and show loader
  elem.setAttribute("disabled", "disabled");
  dataTableBtnText.innerText = "Loading...";
  dataTableLoader.classList.remove("hide");
  dataTableIcon.classList.add("hide");

  if (reportID) {
    // XHR request for fetching document
    bsLib.ajax(
      "GET",
      bsLib.railsHost() + "/trust/certificate_download/" + reportID,
      {},
      true,
      {
        accept: "application/json",
        "content-type": "application/json; charset=utf-8", // Setting content type.
      },
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          var dataRes = bsLib.JSONParse(data.response);

          // enable button and hide loader
          elem.removeAttribute("disabled", "disabled");
          dataTableBtnText.innerText = "Request";
          dataTableLoader.classList.add("hide");
          dataTableIcon.classList.remove("hide");

          if (dataRes.hasOwnProperty("message")) {
            if (
              data.status === 200 &&
              dataRes.message === "File was scheduled for email"
            ) {
              requestStatus = "accepted";

              // close modal
              typeof trustCenterModal !== "undefined"
                ? trustCenterModal.destroy()
                : "";

              // File schedule success
              new bsAlert({
                alertType: "info",
                timeout: 5000,
                text: "<span class='tc__alert-email'></span><span class='tc__alert-text'>The certificate is being prepared. An email will be sent to you with the certificate attached. This may take sometime</span>",
                showClose: false,
                showIcon: true,
                htmlMessage: true,
              });

              trustCenterEDSEvents(reportName, requestStatus); // fire EDs event
            }
          }
        }
      },
      // Custom Error message for statu code 202 - 401
      function (data) {
        if (data.readyState === 4) {
          var dataRes = bsLib.JSONParse(data.response);

          // enable button and hide loader
          elem.removeAttribute("disabled", "disabled");
          dataTableBtnText.innerText = "Request";
          dataTableLoader.classList.add("hide");
          dataTableIcon.classList.remove("hide");

          if (dataRes.hasOwnProperty("message")) {
            if (data.status === 202) {
              signinTrustModal.classList.add("hide");
              publicSigninTrustModal.classList.add("hide");
              trustNDAModal.classList.remove("hide");
              requestStatus = "denied-NDA";

              // open NDA modal form
              openTrustCenterModal(false, reportID, reportName);

              trustCenterEDSEvents(reportName, requestStatus); // fire EDs event
            } else if (data.status === 400) {
              if (dataRes.message === "Invalid certificate id") {
                requestStatus = "denied-invalid-certificate-id";
                displayErrorAlertMessage(dataRes.message);
              } else if (
                dataRes.message === "Disposable domain not allowed to download"
              ) {
                requestStatus = "denied-disposableEmail";
                signinTrustModal.classList.add("hide");
                trustNDAModal.classList.add("hide");
                publicSigninTrustModal.classList.remove("hide");

                // open sign in modal form
                openTrustCenterModal(true, reportID, reportName);
              } else if (
                dataRes.message === "certificate_id is a mandatory param"
              ) {
                requestStatus = "denied-certificate-id-mandatory";
                displayErrorAlertMessage(dataRes.message);
              } else if (
                dataRes.message ===
                "Certificate already downloaded in last 24 hours"
              ) {
                requestStatus = "denied-certificate-already-downloaded";
                displayErrorAlertMessage(dataRes.message);
              } else {
                requestStatus = "denied";
                displayErrorAlertMessage(dataRes.message);
              }

              trustCenterEDSEvents(reportName, requestStatus); // fire EDs event
            } else if (data.status === 401) {
              trustNDAModal.classList.add("hide");
              publicSigninTrustModal.classList.add("hide");
              signinTrustModal.classList.remove("hide");
              requestStatus = "denied-loginRequired";

              // open sign in modal form
              openTrustCenterModal(true, reportID, reportName);

              trustCenterEDSEvents(reportName, requestStatus); // fire EDs event
            } else {
              // server error
              displayErrorAlertMessage(
                "Something went wrong. Please try again."
              );
            }
          } else {
            // 404 error
            displayErrorAlertMessage(
              "404 Error: Something went wrong. Please try again."
            );
          }
        }
      }
    );
  }
}

function trustCenterEDSEvents(reportName, requestStatus) {
  WebEventTracker.logEvent(
    EDS.webEvents,
    "CertificateRequested",
    bsLib.extend(
      {
        certificate_type: document.title,
        certificate_category: trustCertificateCategory,
        report_name: reportName != "" ? reportName : "NA",
        request_status: requestStatus,
      },
      popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
    )
  );
}

function openTrustCenterModal(modalVarFlag, reportID, reportName) {
  var modalContainer = document.querySelector(".tc__modal");
  //show login modal
  if (modalContainer) {
    trustCenterModal = new tingle.modal({
      focusAfterClosed: this,
      setFocusOnCloseIcon: true,
      cssClass: modalVarFlag
        ? ["tc__modal-box"]
        : ["tc__modal-box", "tc__modal-box--var"],
      onClose: function () {
        //Close Event
        trustCenterModal.destroy();
      },
    });
    trustCenterModal.setContent(modalContainer.innerHTML);
    trustCenterModal.open();
  }

  // Attch event listener to signin btn
  var signInBtnElem = document.querySelector(
      ".tc__modal-box #signinTrustModalBtn"
    ),
    publicSigninTrustModalBtn = document.querySelector(
      ".tc__modal-box #publicSigninTrustModalBtn"
    ),
    ndaAcceptBtn = document.querySelector(".tc__modal-box .tc__modal-btn--var");

  // signInBtnElem event listener
  if (signInBtnElem) {
    signInBtnElem.addEventListener("click", function (e) {
      e.preventDefault();
      var redirectLink = pageSlugName
        ? "/users/sign_in?ref=" + pageSlugName
        : "/users/sign_in";
      window.location = window.location.origin + redirectLink;
    });
  }

  // publicSigninTrustModalBtn event listener
  if (publicSigninTrustModalBtn) {
    publicSigninTrustModalBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var redirectLink = pageSlugName
        ? "/users/sign_out?ref=" + pageSlugName
        : "/users/sign_out";
      window.location = window.location.origin + redirectLink;
    });
  }

  if (ndaAcceptBtn) {
    ndaAcceptBtn.addEventListener("click", function (e) {
      e.preventDefault();
      fnAcceptNDAModalRequest(reportID, reportName);
    });
  }
}

function fnAcceptNDAModalRequest(reportID, reportName) {
  var requestStatus,
    trustNDAModalBtn = document.querySelector(
      ".tc__modal-box #trustNDAModalBtn"
    );

  // disable submit button
  trustNDAModalBtn.setAttribute("disabled", "disabled");
  trustNDAModalBtn.innerText = trustNDAModalBtn.getAttribute("data-validation");

  if (reportID) {
    // XHR request for fetching document
    bsLib.ajax(
      "GET",
      bsLib.railsHost() + "/trust/nda/" + reportID,
      {},
      true,
      {
        accept: "application/json",
        "content-type": "application/json; charset=utf-8", // Setting content type.
      },
      // Success message for user token.
      function (data) {
        if (data.readyState === 4 && data.status === 200) {
          var dataRes = bsLib.JSONParse(data.response);

          // enable submit button
          if (trustNDAModalBtn) {
            trustNDAModalBtn.removeAttribute("disabled");
            trustNDAModalBtn.innerText =
              trustNDAModalBtn.getAttribute("data-btn-text");
          }

          if (dataRes.hasOwnProperty("message")) {
            if (
              data.status === 200 &&
              dataRes.message === "File was scheduled for email"
            ) {
              requestStatus = "accepted";
              // close modal
              typeof trustCenterModal !== "undefined"
                ? trustCenterModal.destroy()
                : "";
              // File schedule success
              new bsAlert({
                alertType: "info",
                timeout: 5000,
                text: "<span class='tc__alert-email'></span><span class='tc__alert-text'>The certificate is being prepared. An email will be sent to you with the certificate attached. This may take sometime</span>",
                showClose: false,
                showIcon: true,
                htmlMessage: true,
              });

              trustCenterEDSEvents(reportName, requestStatus); // fire EDs event
            }
          }
        }
      },
      // Custom Error message for 401.
      function (data) {
        if (data.readyState === 4) {
          var dataRes = bsLib.JSONParse(data.response);

          // enable submit button
          if (trustNDAModalBtn) {
            trustNDAModalBtn.removeAttribute("disabled");
            trustNDAModalBtn.innerText =
              trustNDAModalBtn.getAttribute("data-btn-text");
          }

          if (dataRes.hasOwnProperty("message")) {
            if (data.status === 401) {
              requestStatus = "denied-loginRequired";
              displayErrorAlertMessage("Unauthorized Access");
            } else {
              if (
                dataRes.message ===
                "Certificate already downloaded in last 24 hours"
              ) {
                requestStatus = "denied-certificate-already-downloaded";
              } else {
                requestStatus = "denied";
              }
              // error message
              displayErrorAlertMessage(dataRes.message);
            }
            trustCenterEDSEvents(reportName, requestStatus); // fire EDs event
          } else {
            // 404 error
            displayErrorAlertMessage(
              "404 Error: Something went wrong. Please try again."
            );
          }
        }
      }
    );
  }
}

function displayErrorAlertMessage(errorMessage) {
  // close modal
  typeof trustCenterModal !== "undefined" ? trustCenterModal.destroy() : "";

  new bsAlert({
    alertType: "error",
    timeout: 5000,
    showClose: false,
    showIcon: true,
    text: errorMessage
      ? errorMessage
      : "Something went wrong. Please try again.",
  });
}

function fnDownloadCertificateBtn(elem) {
  var reportName = elem
    .closest(".data-table__tbody")
    .querySelector(".data-table__desc").innerText;
  trustCenterEDSEvents(reportName, "accepted"); // fire EDs event
}

window.addEventListener("load", function () {
  var signInBtn = document.querySelector(".data-table__signin-link");
  if (signInBtn && pageSlugName !== "") {
    signInBtn.setAttribute("href", "/users/sign_in?ref=" + pageSlugName);
  }
});
